import { useState } from "react";
import { ChevronDown, Mail, Phone } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const faqs = [
  {
    question: "How do I book a service?",
    answer:
      "Sign in and choose the service you need—travel assistant, accommodation, or ride hailing. Enter your details, review the available options, and confirm your booking. You’ll receive a confirmation once your request is placed.",
  },
  {
    question: "What happens after I place a booking?",
    answer:
      "You’ll receive a confirmation and updates in your dashboard. Depending on the service, a provider will be assigned, and you’ll be notified as the booking progresses.",
  },
  {
    question: "Can I cancel or change my booking?",
    answer:
      "You can cancel from your dashboard up to 12 hours before your trip starts, and you’ll get everything back except Pulo’s 20% commission. After that the booking can no longer be cancelled.",
  },
  {
    question: "How do I know when my driver or tour guide has arrived?",
    answer:
      "You’ll receive in‑app notifications and see real‑time updates in your booking details page.",
  },
  {
    question: "How do I contact support if I need help?",
    answer:
      "Reach out to our support team through the Help Center contact details. We typically respond within a few hours.",
  },
  {
    question: "How do I get a refund if there’s need for it?",
    answer:
      "Refund eligibility depends on service type and booking status. Submit a request via your dashboard or contact support for assistance.",
  },
];

function HelpCenter() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="min-h-screen ">
      <Header />

      <section className="relative w-full h-[300px] sm:h-[420px] xl:h-[50vh]  flex items-center justify-center bg-[#61013B]">
        {/* <div className="absolute inset-0 opacity-30">
          <div className="absolute -top-20 -left-20 h-60 w-60 rounded-full bg-[#a45078]" />
          <div className="absolute -bottom-28 right-10 h-72 w-72 rounded-full bg-[#7a1d53]" />
          <div className="absolute top-10 right-[-80px] h-48 w-48 rounded-full bg-[#3b0027]" />
        </div> */}
        <div className="relative mx-auto w-full max-w-5xl px-6 py-16 text-center text-white">
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight">Help Center</h1>
          <p className="mt-4 text-sm sm:text-xl text-white/90 font-medium">
            Welcome to Pulo Help Center. Whether you are a user or service provider,
            we’ve got answers to your question.
          </p>
        </div>
      </section>

      <section className="mx-auto w-full sm:max-w-[80%] sm:px-6 py-12">
        <div className=" bg-white p-6 shadow-sm">
          <div className="divide-y divide-[#f1e6ee]">
            {faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={faq.question} className="py-4">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    className="flex w-full items-center justify-between text-left text-sm sm:text-lg font-semibold text-[#2b1b23]"
                  >
                    {faq.question}
                    <ChevronDown
                      className={`h-5 w-5 text-[#7a0051] transition-transform ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  {isOpen ? (
                    <p className="mt-3 text-md font-medium text-[#353535] leading-relaxed">
                      {faq.answer}
                    </p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>

        <div className="px-6 mt-10 text-center">
          <h2 className="text-2xl font-semibold text-[#7a0051]">
            You still have a question?
          </h2>
          <p className="mt-4 text-md font-medium text-[#5c5157]">
            If you cannot find answer to your question in our FAQ you can always contact us and we will answer you shortly.
          </p>

          <div className="mt-8 flex justify-between  items-center max-sm:gap-2  flex-row sm:justify-around">
            <div className="flex flex-col items-center gap-4">
              <div className="flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-xl bg-[#f1e7ec] text-[#6b0c44]">
                <Mail className="h-6 w-6" />
              </div>
              <p className="text-sm font-medium text-[#1f151b] sm:text-xl">
                Support@pulohq.com
              </p>
            </div>
            <div className="flex flex-col items-center gap-4">
              <div className="flex  h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-2xl bg-[#f1e7ec] text-[#6b0c44]">
                <Phone className="h-6 w-6" />
              </div>
              <p className="text-sm font-medium text-[#1f151b] sm:text-xl">
                +234 812 924 2939
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default HelpCenter;
